import { Dispatch, FunctionComponent, SetStateAction, useEffect } from "react";
import Shortcut from "@components/core/shortcuts/Shortcut";
import { ViewDetailResponseDto } from "@state/transactions/response/view.detail.response.dto";
import { SHORTCUTS_ENUM } from "@/utils/enums/shortcuts.enum";

interface ShortcutsProps {
  views: ViewDetailResponseDto[];
  selectedShortcut: string;
  setSelectedShortcut: Dispatch<SetStateAction<string>>;
  className?: string;
}

const Shortcuts: FunctionComponent<ShortcutsProps> = ({
  views,
  selectedShortcut,
  setSelectedShortcut,
  className = "",
}) => {
  const viewsLength = views.length;

  useEffect(() => {
    const hash = location.hash?.substring(1); // remove '#'
    if (hash && hash.length > 0) {
      const values = Object.values(SHORTCUTS_ENUM);
      const keys = Object.keys(SHORTCUTS_ENUM);

      const index = values.findIndex((item) => item.indicator === hash);
      if (index !== -1) {
        const shortcutName = keys[index];
        setSelectedShortcut(shortcutName);
      }
    }
  }, []);

  const handleClick = (view: ViewDetailResponseDto) => {
    setSelectedShortcut(
      selectedShortcut === view.shortcut ? "" : view.shortcut,
    );
  };

  return (
    <div
      className={`app-shortcuts ${
        views ? `multiple multiple-${viewsLength}` : ""
      } ${className}`}
    >
      {views &&
        views.map((view, index) => (
          <Shortcut
            key={index}
            active={view.shortcut === selectedShortcut ? "active" : ""}
            {...view}
            onClick={() => handleClick(view)}
          />
        ))}
    </div>
  );
};

export default Shortcuts;
